import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Event, EventRegistration, PaymentMethod } from 'resources'
import actionProps from 'actions'

import { Form as BraintreeForm } from 'components/braintree'
import { Form, Field } from 'components/form'
import { Photos, CustomEventQuestions, isTicketsExist, EventDate } from 'components/event'
import parseFloatMoney from 'utils/parse-float'
import CreditCardForm from './_cc_form'
import RegisterButton from './_register_button'
import RegistrationClosed from './_registration_closed'
import NoMoreTickets from './_no_more_tickets'
import NumericInput from 'react-numeric-input'
import { Money } from 'components/utilities'
import { Col, Row } from 'react-bootstrap'

class UnauthenticatedRegisterIndex extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      authorization: null,
      event: null,
      eventRegistration: {
        variable_amount: 0,
      },

      ready: false,
      cardType: 'unknown',
      isLoading: false,
      validityErrors: {},
    }
  }

  componentDidMount() {
    this.doObjectRetrieve()
  }

  onPaymentAuthorizationCreate = ({ data: { authorization } }) => this.setState({ authorization })
  onBraintreeReady = () => this.setState({ ready: true })
  onError = errors => this.setState({ errors, isLoading: false })

  onVariableAmountChange = value => {
    const { eventRegistration } = this.state
    const amount = parseFloatMoney(value)

    this.setState({
      eventRegistration: {
        ...eventRegistration,
        variable_amount: amount,
      },
    })

    if (amount === 0) {
      this.setState({ errors: null })
    }
  }

  onChange = e => {
    const value = e.target.value
    const name = e.target.name.split('.')[1]

    this.setState(state => {
      const newState = _.clone(state)
      newState.eventRegistration[name] = value
      newState.error = null
      return newState
    })
  }

  onChangeTickets = value => {
    this.setState(state => {
      const newState = _.clone(state)
      newState.eventRegistration.tickets = value
      newState.error = null
      return newState
    })
  }

  onChangeEventAnswer = (value, index, field = 'answer') => {
    const { eventRegistration } = this.state
    _.set(eventRegistration, `event_answers.[${index}].${field}`, value)
    this.setState({ eventRegistration })
  }

  onChangeEventCheckboxAnswer = (target, index) => {
    const { eventRegistration } = this.state
    const newValue = target.checked
      ? [..._.get(eventRegistration, `event_answers.[${index}].answer`, []), target.value]
      : _.remove(
        _.get(eventRegistration, `event_answers.[${index}].answer`, []),
        ans => ans !== target.value
      )
    _.set(eventRegistration, `event_answers.[${index}].answer`, newValue)
    this.setState({ eventRegistration })
  }

  onProcessPayment = ({ nonce }) => {
    this.setState(state => {
      const newState = _.clone(state)
      newState.eventRegistration.braintree_nonce = nonce
      return newState
    })

    this.onProcessCreate()
  }

  onProcessCreate = () => {
    const { eventRegistration, event } = this.state
    this.setState({ ready: false })

    EventRegistration.createPublic({
      data: {
        event_registration: {
          event_id: event.id,
          name: eventRegistration.name || '',
          email: eventRegistration.email || '',
          tickets: eventRegistration.tickets,
          event_answers: eventRegistration.event_answers || [],
          event_optional_addons: eventRegistration.event_optional_addons || [],
          braintree_nonce: eventRegistration.braintree_nonce,
          variable_amount: eventRegistration.variable_amount,
        },
      },
      onSuccess: ({ data }) => {
        this.props.actions.routePush(`/register/${data.id}/confirmation`)
      },
      onFailure: ({ data }) => {
        this.setState({
          ready: true,
          error: _.get(data, 'event_registration'),
        })
      },
    })
  }

  onValidityErrorChange = (field, validity) => {
    const { validityErrors } = this.state

    if (validity) {
      delete validityErrors[field]
    } else {
      validityErrors[field] = true
    }

    this.setState({ validityErrors })
  }

  onBrainTreeSubmitClick = e => {
    // skip Braintree when amount is 0
    if (this.totalCost() === 0) {
      e.preventDefault()
      this.onProcessCreate()
    }
  }

  objectQuery = `
    event {
      name
      description
      cost_type
      cost
      maximum_tickets
      event_questions
      optional_addons
      registration_closes_on
      background_color
      header_color
      start_date
      end_date

      data {
        tickets_sold
      }

      document_folder {
        documents {
          url
        }
      }

      owner {
        primary_logo {
          public_url
        }
        secondary_logo {
          public_url
        }
      }

    }
  `

  doObjectRetrieve = () => {
    let { eventRegistration } = this.state

    Event.retrievePublic({
      id: this.props.params.id,
      query: this.objectQuery,
      onSuccess: ({ data }) => {
        eventRegistration = {
          ...eventRegistration,
          event_answers: data.event_questions,
          event_optional_addons: data.optional_addons,
        }

        if (!_.isNil(data.maximum_tickets)) {
          eventRegistration.tickets = 1
        }

        if (data.cost > 0 || data.cost_type === 'variable' || this.isOptionCost(data)) {
          PaymentMethod.authorization({
            onSuccess: this.onPaymentAuthorizationCreate,
          })
        }

        this.setState({
          event: data,
          eventRegistration,
        })

        this.props.actions.setCustomWrapperStyles({
          backgroundColor: _.get(data, 'background_color', null),
          headerColor: _.get(data, 'header_color', null),
          primaryLogo: _.get(data, 'owner.primary_logo.public_url', null),
          secondaryLogo: _.get(data, 'owner.secondary_logo.public_url', null),
        })
      },
    })
  }

  onChangeEventAddon = index => e => {
    const { eventRegistration } = this.state

    _.set(eventRegistration, `event_optional_addons.[${index}].quantity`, e)
    this.setState({ eventRegistration })
  }

  getOptionalQuantity = index => {
    const {
      eventRegistration: { event_optional_addons: eventOptionalAddons },
    } = this.state
    return _.get(eventOptionalAddons[index], 'quantity', 0)
  }

  getOptionalTotalCost = index => {
    const {
      eventRegistration: { event_optional_addons: eventOptionalAddons },
    } = this.state
    return eventOptionalAddons[index].cost * this.getOptionalQuantity(index)
  }

  getAllOptionalCost = () => {
    const {
      eventRegistration: { event_optional_addons: eventOptionalAddons },
    } = this.state

    let total = 0
    _.map(eventOptionalAddons, (opt, index) => {
      total += this.getOptionalTotalCost(index)
    })

    return total
  }

  getTotalTicketsAmount = () => {
    const { event, eventRegistration: eR } = this.state
    const ticketCost = event.cost_type === 'variable' ? eR.variable_amount || 0 : event.cost
    return ticketCost * (eR.tickets || 1)
  }

  totalCost = () => this.getTotalTicketsAmount() + this.getAllOptionalCost()

  isOptionCost = event => !!_.find(event.optional_addons, item => item.cost > 0)

  getButtonStyles = () => {
    const { event } = this.state

    if (!event) {
      return {}
    }

    return {
      backgroundColor: event.header_color,
      borderColor: event.header_color,
    }
  }

  renderBraintreeForm = () => {
    const { authorization, ready } = this.state
    const { cardType, event, eventRegistration, errors, error, validityErrors } = this.state

    const disabled = !ready

    return (
      <BraintreeForm
        authorization={authorization}
        onError={this.onError}
        onBraintreeReady={this.onBraintreeReady}
        onProcessPayment={this.onProcessPayment}
        onCardTypeChange={cType => this.setState({ cardType: cType })}
        onValidityErrorChange={this.onValidityErrorChange}
      >
        {event.cost_type === 'variable' && (
          <Field
            className="row"
            labelClassName="col-md-12"
            inputSize={6}
            name="event_registration.variable_amount"
            onChange={this.onVariableAmountChange}
            money
            label={<span>Amount to pay</span>}
          />
        )}

        <CreditCardForm
          {...{
            cardType,
            event,
            eventRegistration,
            errors,
            error,
            validityErrors,
          }}
          ticketsCost={this.getTotalTicketsAmount()}
          totalCost={this.totalCost()}
          addons={eventRegistration.event_optional_addons}
        />

        <RegisterButton
          disabled={disabled}
          onClick={this.onBrainTreeSubmitClick}
          styles={this.getButtonStyles()}
        />
      </BraintreeForm>
    )
  }

  render() {
    const { openModal, closeModal } = this.props.actions
    const { event, error, eventRegistration } = this.state

    if (_.isNil(event)) return null

    const isShowBraintree =
      event.cost || event.cost_type === 'variable' || this.getAllOptionalCost() > 0

    if (moment(event.registration_closes_on).endOf('day').isBefore(moment())) {
      return <RegistrationClosed event={event} />
    }

    if (!isTicketsExist(event)) {
      return <NoMoreTickets event={event} />
    }

    return (
      <div className="account-wrapper account-wrapper-wide">
        <h3>{_.get(event, 'name')} registration</h3>

        <div className="account-form account-body">
          <Form action={() => { }} onSuccess={() => { }}>
            <Photos event={event} isPublic />

            <p
              dangerouslySetInnerHTML={{ __html: _.get(event, 'description') }}
              className="m-b-2"
            />

            <EventDate startDate={event.start_date} endDate={event.end_date} />

            <hr />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="event_registration.name"
              hint={_.get(error, 'name.[0]')}
              validationState={_.get(error, 'name.[0]') && 'error'}
              onChange={this.onChange}
              label={
                <span>
                  <span className="text-danger">* </span>
                  Your name:
                </span>
              }
              autoFocus
            />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="event_registration.email"
              hint={_.get(error, 'email.[0]')}
              validationState={_.get(error, 'email.[0]') && 'error'}
              onChange={this.onChange}
              label={
                <span>
                  <span className="text-danger">* </span>
                  Your email:
                </span>
              }
            />

            <hr />

            <CustomEventQuestions
              event={event}
              errors={_.get(error, 'event_answers.[0]')}
              onChangeEventAnswer={this.onChangeEventAnswer}
              onChangeEventCheckboxAnswer={this.onChangeEventCheckboxAnswer}
              labelClassName="col-md-12"
              inputSize={6}
              openModal={openModal}
              closeModal={closeModal}
            />

            {!_.isNil(event.maximum_tickets) && (
              <div>
                <hr />

                <Field
                  label="Number of tickets:"
                  labelFor="event_registration.tickets"
                  errorKey="event_registration.tickets"
                  id="event_registration.tickets"
                  inputWrapClassName="is-flex"
                  hint={_.get(error, 'tickets.[0]')}
                  validationState={_.get(error, 'tickets.[0]') && 'error'}
                  inputSize={9}
                >
                  <Row>
                    <Col md={12}>
                      <NumericInput
                        className="form-control"
                        name="event_registration.tickets"
                        mobile
                        min={1}
                        value={_.get(eventRegistration, 'tickets', 1)}
                        onChange={this.onChangeTickets}
                        onValid={this.onChangeTickets}
                      />
                    </Col>
                  </Row>
                </Field>
              </div>
            )}

            {_.map(event.optional_addons, (item, index) => (
              <div className="clearfix false form-group has-feedback" key={index}>
                <label
                  htmlFor={`event_registration.addon[${index}]`}
                  className="col-md-3 control-label"
                >
                  {item.name} (<Money amount={item.cost} />)
                </label>

                <div className="col-md-3">
                  <NumericInput
                    name={`event_registration.addon[${index}]`}
                    className="form-control"
                    min={0}
                    value={this.getOptionalQuantity(index)}
                    onChange={this.onChangeEventAddon(index)}
                    mobile
                  />
                </div>
              </div>
            ))}

            <div className="m-l-1">
              {!!isShowBraintree || (
                <RegisterButton
                  disabled={false}
                  onClick={() => this.onProcessCreate()}
                  styles={this.getButtonStyles()}
                />
              )}
            </div>
          </Form>

          {isShowBraintree && this.renderBraintreeForm()}
        </div>
      </div>
    )
  }
}

export default connect(null, actionProps)(UnauthenticatedRegisterIndex)
